import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { ErrorHandlerService, getApolloLink } from '@ppl/auth';
import { patchClient } from '@ppl/utils/graphql.utils';
import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import type { MutationOptions, QueryOptions } from '@apollo/client/core';
import type { ErrorCode } from '@ppl/auth';
import type { Query } from '@ppl/graphql-public-api';
import type { DocumentNode } from 'graphql';


const PUBLIC_ENDPOINT_NAME = 'publicEndpoint';

@Injectable()
export class PublicApiService {

  get gqlClient() {
    return this.getGraphqlClient();
  }

  constructor(
    private apollo: Apollo,
    private httpLink: HttpLink,
    private errorHandlerService: ErrorHandlerService
  ) { }

  getGraphqlClient() {
    if (!this.apollo.use(PUBLIC_ENDPOINT_NAME)) {
      this.apollo.create({
        link: getApolloLink({
          httpLink: this.httpLink,
          gqlUrl: environment.apiPublicGqlUrl,
          errorHandlerService: this.errorHandlerService
        }),
        cache: new InMemoryCache()
      }, PUBLIC_ENDPOINT_NAME);
    }
    return patchClient(this.apollo.use(PUBLIC_ENDPOINT_NAME));
  }

  query<V = { [k: string]: any }>(options: PublicApiQueryOptions<V>) {
    return this.gqlClient.query<Query>({
      query: options.query,
      variables: options.variables
    });
  }

  mutate<T, V = { [k: string]: any }>(options: PublicApiMutateOptions<T, V>) {
    return this.gqlClient.mutate<T, V>({
      mutation: options.mutation,
      variables: options.variables,
      context: options.context
    });
  }
}

interface PublicApiMutateOptions<T, V> extends Pick<MutationOptions<T, V>, 'variables'> {
  mutation: () => DocumentNode;
  variables?: V;
  context?: PublicApiMutateContext;
}

interface PublicApiQueryOptions<V> extends Pick<QueryOptions<V>, 'variables' | 'fetchPolicy'> {
  query: () => DocumentNode
}

interface PublicApiMutateContext {
  // whitelist error codes (don't report them to user)
  errorWhiteList?: ErrorCode[];
}

